module.exports = __webpack_public_path__ + "img/img_21_brand_retail@3x.b08f1c76.png";